module.exports = __webpack_public_path__ + "img/955996192.14c90fff.jpg";